import LoadingComponent from "./LoadingComponent";

const Loader = ({
  title = "Loading...",
  message = "Please wait...",
}) => {
  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center"
      style={{
        zIndex: 9999,
      }}
    >
      <LoadingComponent loading />

      <h4>{title}</h4>

      <p className="text-muted">{message}</p>
    </div>
  );
};

export default Loader;